/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { sharedListPagesFilterStyle } from "@monsma/App/WidgetExtensions/MyAccount/MyAccountListPagesExtension";
import { savedOrderListFilterStyles } from "@monsma/Overrides/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderListFilterStyles.headingGridItem = {
    css: css`
        display: none;
    `,
};

savedOrderListFilterStyles.container = sharedListPagesFilterStyle.container;

savedOrderListFilterStyles.orderTotalGridItem = sharedListPagesFilterStyle.normalGridItem;

savedOrderListFilterStyles.orderTotalContainer = sharedListPagesFilterStyle.customContainer;

savedOrderListFilterStyles.orderTotalOperatorGridItem = {
    width: [12, 6, 6, 6, 6],
};

savedOrderListFilterStyles.orderTotalAmountGridItem = {
    ...savedOrderListFilterStyles.orderTotalOperatorGridItem,
    css: css`
        align-items: flex-end;
    `,
};

savedOrderListFilterStyles.orderTotalAmountTextField = {};

savedOrderListFilterStyles.datesGridItem = sharedListPagesFilterStyle.normalGridItem;

savedOrderListFilterStyles.datesContainer = sharedListPagesFilterStyle.customContainer;

savedOrderListFilterStyles.fromGridItem = sharedListPagesFilterStyle.dateGridItem;

savedOrderListFilterStyles.toGridItem = sharedListPagesFilterStyle.dateGridItem;

savedOrderListFilterStyles.buttonsItem = sharedListPagesFilterStyle.buttonsItem;

savedOrderListFilterStyles.clearFiltersButton = sharedListPagesFilterStyle.clearFiltersButton;
